import YFormPostSlug from './PostSlug';

export { YFormPostSlug };
export default YFormPostSlug;
